// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamSelection_container__24u8P","triggered":"TeamSelection_triggered__3S2ro","loading":"TeamSelection_loading__2fHOe"};